import { breakpoints } from '../../foundations/breakpoints';
import { MultiDynamicMediaImageConfigs } from './index';

export const fullWidthImageConfigs: MultiDynamicMediaImageConfigs = [
  {
    aspectRatio: '9-16',
    sizes: '100vw',
    media: '(max-aspect-ratio: 3/4)'
  },
  {
    aspectRatio: '3-4',
    sizes: '100vw',
    media: '(max-aspect-ratio: 4/3)'
  },
  {
    aspectRatio: '4-3',
    sizes: '100vw',
    media: '(max-aspect-ratio: 16/9)'
  },
  {
    aspectRatio: '16-9',
    sizes: '100vw',
    media: '(min-aspect-ratio: 16/9)'
  }
];

export const mobileFullDesktopHalfImageConfig: MultiDynamicMediaImageConfigs = [
  {
    aspectRatio: '1-1',
    sizes: '100vw',
    media: `(max-width: ${breakpoints.m}px)`
  },
  {
    aspectRatio: '1-1',
    media: `(min-width: ${breakpoints.m}px)`,
    sizes: '50vw'
  }
];
